// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "1 Paralipomenon (1 Chronicles)",
  bookSlug: "1-paralipomenon",
  chapter: 8,
  argument: "The posterity of Benjamin is further declared down to Saul. His issue.",
  verses: [
    { n: 1, text: "Now Benjamin begot Bale, his first-born, Asbel, the second, Ahara, the third," },
    { n: 2, text: "Nohaa, the fourth, and Rapha, the fifth." },
    { n: 3, text: "And the sons of Bale were: Addar, and Gera, and Abiud," },
    { n: 4, text: "And Abisue, and Naaman, and Ahoe," },
    { n: 5, text: "And Gera, and Sephuphan, and Huram." },
    { n: 6, text: "These are the sons of Ahod, heads of families that dwelt in Gabaa, who were removed into Manahath." },
    { n: 7, text: "And Naaman, and Achia, and Gera, he removed them, and begot Oza, and Ahiud." },
    { n: 8, text: "And Saharim begot in the land of Moab, after he sent away Husim and Bara, his wives." },
    { n: 9, text: "And he begot of Hodes, his wife, Jobab, and Sebia, and Mosa, and Molchom," },
    { n: 10, text: "And Jehus, and Sechia, and Marma. These were his sons, heads of their families." },
    { n: 11, text: "And Mehusim begot Abitob, and Elphaal." },
    { n: 12, text: "And the sons of Elphaal: were Heber, and Misaam, and Samad: who built Ono, and Lod, and its daughters." },
    { n: 13, text: "And Baria, and Sama, were heads of their kindreds that dwelt in Aialon: these drove away the inhabitants of Geth." },
    { n: 14, text: "And Ahio, and Sesac, and Jerimoth," },
    { n: 15, text: "And Zabadia, and Arod, and Heder," },
    { n: 16, text: "And Michael, and Jespha, and Joha, the sons of Baria," },
    { n: 17, text: "And Zabadia, and Mosollam, and Hezeci, and Heber," },
    { n: 18, text: "And Jesamari, and Jezlia, and Jobab, sons of Elphaal," },
    { n: 19, text: "And Jacim, and Zechri, and Zabdi," },
    { n: 20, text: "And Elioenai, and Selethai, and Elial," },
    { n: 21, text: "And Adaia, and Baraia, and Samareth, the sons of Semei." },
    { n: 22, text: "And Jespham, and Heber, and Eliel," },
    { n: 23, text: "And Abdon, and Zechri, and Hanan," },
    { n: 24, text: "And Hanania, and Elam, and Anathothia," },
    { n: 25, text: "And Jephdaia, and Phanuel the sons of Sesac." },
    { n: 26, text: "And Samsari, and Sohoria, and Otholia," },
    { n: 27, text: "And Jersia, and Alia, and Zechri, the sons of Jeroham." },
    { n: 28, text: "These were the chief fathers, and heads of their families, who dwelt in Jerusalem." },
    { n: 29, text: "And at Gabaon dwelt Abigabaon, and the name of his wife was Maacha:" },
    { n: 30, text: "And his first-born son Abdon, and Sur, and Cis, and Baal, and Nadab," },
    { n: 31, text: "And Gedor, and Ahio, and Zacher, and Macelloth." },
    { n: 32, text: "And Macelloth begot Samaa: and they dwelt over-against their brethren in Jerusalem, with their brethren." },
    { n: 33, text: "And Ner begot Cis, and Cis begot Saul. And Saul begot Jonathan and Melchisua, and Abinadab, and Esbaal." },
    { n: 34, text: "And the son of Jonathan was Meribbaal: and Meribbaal begot Micha." },
    { n: 35, text: "And the sons of Micha, were Phithon, and Melech, and Tharaa, and Ahaz." },
    { n: 36, text: "And Ahaz begot Joada: and Joada begot Alamath, and Azmoth, and Zamri: and Zamri begot Mosa," },
    { n: 37, text: "And Mosa begot Banaa, whose son was Rapha, of whom was born Elasa, who begot Asel." },
    { n: 38, text: "And Asel had six sons, whose names were Ezricam, Bochru, Ismahel, Saria, Obdia, and Hanan. All these were the sons of Asel." },
    { n: 39, text: "And the sons of Esec, his brother, were Ulam, the first-born, and Jehus, the second, and Eliphalet, the third." },
    { n: 40, text: "And the sons of Ulam were most valiant men, and archers of great strength: and they had many sons and grandsons, even to a hundred and fifty. All these were children of Benjamin." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Benjamin. Some farther particulars of his genealogy are given, for the honour of Saul; (Calmet) and many of those, who returned from captivity, are mentioned, 1 Esdras x. 11. (Sanctius) — Bale, &c., are called Bela, (Menochius; chap. vii. 6.) Jadiel, and Ahiram, or Echi, Numbers xxvi. 36., and Genesis xlvi.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Nohaa is probably styled Bechor; and Rapha, Ros, in Genesis.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Addar, Ared or Hered.", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "Ahod, the judge, Judges iii. 15. — Manahath; the Menuchat, in the tribe of Juda, (chap. ii. 54.) after the captivity. (Calmet) — Abulensis thinks Manahath was in Moab,", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "And. Literally, \"but,\" autem. (Haydock) — The sentence is clearer without this particle. (Menochius) — Naaman was the first-born of Ahod; and Gera prevailed on his brethren to leave Gabaa, (Tirinus) and was probably the father of Oza.", attribution: "Calmet" }
    ] },
    { verse: 11, notes: [
      { text: "Mehusim. Hebrew and Septuagint, \"of Husim (ver. 8) he begot.\"", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Ono was three miles from Lod, or Diospolis, (Lightfoot) built after the return from Babylon, (1 Esdras ii. 23.; Calmet) in the territory of Benjamin.", attribution: "Menochius" }
    ] },
    { verse: 13, notes: [
      { text: "And Sama. They are supposed to have been sons of Elphaal. (Calmet) — Aialon belonged to Dan, Josue xix. 42. But it was near Benjamin, (Menochius) and was probably occupied by people chiefly of that tribe. (Haydock) — Geth. We know not at what period.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Baria, son of Elphaal. Whether the following were his brothers does not appear certain, as it seems more natural to have placed all his father's children together,", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Semei; perhaps Sama,", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Sesac, probably mentioned in", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "(Calmet) — Septuagint have \"Sosek,\" in both places.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Families. Hebrew, \"These were heads of the fathers by their generations, chief men.\" (Protestants) (Haydock) — Jerusalem, probably after the captivity. We find none of these names from ver. 14, in the days of Josue; and it was not easy for people to establish themselves at Jerusalem, till David had expelled the Jebusites. (Calmet) — Yet we find that the tribes of Juda and Benjamin had seized the lower city long before, Josue xviii. 28.", attribution: "Haydock" }
    ] },
    { verse: 29, notes: [
      { text: "Dwelt. Literally, \"they dwelt.\" But Hebrew and Septuagint, \"in Gabaon, dwelt the father of Gaboan,\" (Haydock) who was called Jehiel, (chap. ix. 35.) or Abiel, 1 Kings ix. 1. (Calmet) — The following verses are repeated in the next chapter, (Haydock) and seem to have been originally the same; though now many variations occur, which shew that \"every Hebrew letter\" has not been preserved.", attribution: "Kennicott" }
    ] },
    { verse: 30, notes: [
      { text: "Baal. Add, \"and Ner,\" (", attribution: "Haydock" }
    ] },
    { verse: 33, notes: [
      { text: ", and chap. ix. 36.) as the Septuagint have it here also.", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "Zacher, or Zacharias, chap. ix. Hebrew omits the following name, as well as (Haydock) the end of the preceding one. (Kennicott) — The Alexandrian Septuagint has the same faults. But the Vatican retains Macelloth.", attribution: "Haydock" }
    ] },
    { verse: 32, notes: [
      { text: "Over-against, in the vicinity, while some remained at Gabaon. See Genesis xvi. 12. (Calmet) — The family of Cis resided at Gabaa, 1 Kings x. 26.", attribution: "Menochius" }
    ] },
    { verse: 34, notes: [
      { text: "Meribbaal, alias Mephiboseth, 2 Kings iv. 4., (Challoner) and 2 Kings ix.", attribution: "Menochius" }
    ] },
    { verse: 36, notes: [
      { text: "Joada, or Jara, chap. ix. 42. (Calmet) — \"Strange mistakes these!\"", attribution: "Kennicott" }
    ] },
    { verse: 40, notes: [
      { text: "Archers, particularly the natives of Gabaa, Judges xx. 16. Jonathan is praised for his skill, 2 Kings i. 22. (Menochius) — Benjamin. We might hence conclude that here ended the genealogy of that family. Yet we find it partly repeated in the following chapter,", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
